import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import _Button from "../../generic/_Button";
import _Input from "../../generic/_Input";
import _Select from "../../generic/_Select";
import { useSaveTemplate } from "../../campaigns/hooks/useSaveTemplate";
const _ModalSaveTemplate = (props) => {
  const { data, title = "", onClose, visible } = props;

  const {
    formik,
    _validate,
    isLoading: isLoadingSave,
    handleReset,
  } = useSaveTemplate(data, onClose);

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <_Input
          title="Nombre"
          value={formik.values.name}
          onChange={(e) => formik.setFieldValue("name", e.target.value)}
          placeholder="Escriba el nombre de identificación para su template"
          onBlur={formik.handleBlur}
          errors={formik.errors && formik.errors.name}
          isError={formik.errors && formik.errors.name ? true : false}
        />
        <_Select
          title="Categoria por Caso de Uso"
          value={formik.values.category}
          onChange={(e) => formik.setFieldValue("category", e.target.value)}
          options={[
            { label: "Selecciona una categoría", value: "" },
            { label: "Promocional", value: "PROMOTIONAL" },
            { label: "Contraseñas de un solo uso (OTP)", value: "OTP" },
            { label: "Multiuso", value: "MULTI-USE" },
            { label: "Transaccional", value: "TRANSACTIONAL" },
          ]}
          onBlur={formik.handleBlur}
          errors={formik.errors && formik.errors.category}
          isError={formik.errors && formik.errors.category ? true : false}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cancelar"
          style="none"
          onClick={() => {
            onClose();
            handleReset();
          }}
          loading={isLoadingSave}
          disabled={isLoadingSave}
        />

        <_Button
          title="Guardar"
          style="primary"
          onClick={async () => {
            _validate();
          }}
          loading={isLoadingSave}
          disabled={isLoadingSave}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalSaveTemplate.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

export default _ModalSaveTemplate;
